module.exports = __webpack_public_path__ + "img/gsb2.0a215339.png";